var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "createProductDialog",
          attrs: {
            visible: _vm.dialogVisible,
            width: "40%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("p", [_vm._v("生成预算商品")]),
            _c("p", [
              _vm._v(
                "(您将按照下方信息生成预算商品，订单产生后若无后台供应商接单，则订单自动失效)"
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("p", [
                _vm._v(
                  "您想从 " +
                    _vm._s(_vm.resourceObj.nameCn) +
                    " 采购得产品描述："
                ),
              ]),
              _c("el-input", {
                model: {
                  value: _vm.resourceObj.nameCn,
                  callback: function ($$v) {
                    _vm.$set(_vm.resourceObj, "nameCn", $$v)
                  },
                  expression: "resourceObj.nameCn",
                },
              }),
              _c("el-input", {
                model: {
                  value: _vm.stockObj.productNameCn,
                  callback: function ($$v) {
                    _vm.$set(_vm.stockObj, "productNameCn", $$v)
                  },
                  expression: "stockObj.productNameCn",
                },
              }),
              _c("el-input", {
                model: {
                  value: _vm.stockObj.productDesc,
                  callback: function ($$v) {
                    _vm.$set(_vm.stockObj, "productDesc", $$v)
                  },
                  expression: "stockObj.productDesc",
                },
              }),
              _c(
                "div",
                [
                  _c("span", [_vm._v("采购预算")]),
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.stockObj.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockObj, "price", $$v)
                      },
                      expression: "stockObj.price",
                    },
                  }),
                  _c("currency-autocomplete", { attrs: { obj: _vm.stockObj } }),
                  _c("span", [_vm._v("采购数量")]),
                  _c("el-input", {
                    staticStyle: { width: "0.7rem" },
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.stockObj.stockNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockObj, "stockNumber", $$v)
                      },
                      expression: "stockObj.stockNumber",
                    },
                  }),
                  _vm._v(
                    " 总采购预算：" +
                      _vm._s(_vm.stockObj.price * _vm.stockObj.stockNumber) +
                      _vm._s(_vm.stockObj.currency) +
                      " "
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", [_vm._v("销售价格")]),
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.stockObj.salePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockObj, "salePrice", $$v)
                      },
                      expression: "stockObj.salePrice",
                    },
                  }),
                  _vm._v(
                    " 总销售价格：" +
                      _vm._s(
                        _vm.stockObj.salePrice * _vm.stockObj.stockNumber
                      ) +
                      _vm._s(_vm.stockObj.currency) +
                      " "
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-button", { on: { click: _vm.save } }, [
                    _vm._v("保存并加入行程轴"),
                  ]),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.resourceObj.state === 1
        ? _c("add-site-product-dialog", {
            ref: "addProductDialog",
            attrs: { chenckBudgteObj: _vm.chenckBudgteObj, keyStr: _vm.keyStr },
            on: {
              closeDialog: function ($event) {
                _vm.dialogVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.resourceObj.state === 0
        ? _c("add-hotel-product-dialog", {
            ref: "addProductDialog",
            on: {
              closeDialog: function ($event) {
                _vm.dialogVisible = false
              },
            },
          })
        : _vm._e(),
      (_vm.resourceObj.isLinkProduct == -1 &&
        (_vm.resourceObj.state === 3 || _vm.resourceObj.state === 5)) ||
      _vm.resourceObj.isLinkProduct == 3 ||
      _vm.resourceObj.state === 5
        ? _c("add-traffic-product-dialog", {
            ref: "addProductDialog",
            on: {
              closeDialog: function ($event) {
                _vm.dialogVisible = false
              },
            },
          })
        : _vm._e(),
      _vm.resourceObj.state === 4 || _vm.resourceObj.isLinkProduct == 4
        ? _c("add-meal-product-dialog", {
            ref: "addProductDialog",
            on: {
              closeDialog: function ($event) {
                _vm.dialogVisible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }